import React from 'react';
import {
  Box,
} from '@mui/material';

// Import individual components
import SummaryKPIs from './SummaryKPIs';
import FunnelAnalysis from './FunnelAnalysis';
import LeadSourceAnalysis from './LeadSourceAnalysis';
import LeadTable from './LeadTable';

const LeadReportDetails = ({ dateRangeState, periodType, selectedTeams = [] }) => {

  return (
    <Box 
      sx={{
        flexGrow: 1,
        pt: 0,
        pb: 3,
        px: { xs: 2, sm: 3 },
      }}
    >
      {/* Content Sections */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      {/* Summary KPIs */}
      <SummaryKPIs dateRangeState={dateRangeState} selectedTeams={selectedTeams} />

      {/* Funnel Analysis and Lead Source Analysis - Side by Side */}
      <Box 
        sx={{ 
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
          gap: 3,
          alignItems: 'stretch'
        }}
      >
        <FunnelAnalysis dateRangeState={dateRangeState} selectedTeams={selectedTeams} />
        <LeadSourceAnalysis dateRangeState={dateRangeState} selectedTeams={selectedTeams} />
      </Box>

      {/* Lead Table */}
      <LeadTable dateRangeState={dateRangeState} selectedTeams={selectedTeams} />
      </Box>
    </Box>
  );
};

export default LeadReportDetails;